const ITENS = ['Geladeiras', 'Freezers', 'Fogões', 'Smart TVs', 'Microondas', 'Fornos', 'Fritadeiras', 'Batedeiras', 'Liquidificadores', 'Utensílios', 'Ferros de Passar', 'Máquinas de Corte', 'Linha Hair', 'Chaleiras e Cafeteiras', 'Centrífugas', 'MK Eletromóveis', 'Consulte condições de pagamento'];

export default function Marquee() {
  const lista = [...ITENS, ...ITENS];
  return (
    <div className="overflow-hidden bg-mk-red py-3 select-none" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
        {lista.map((item, i) => (
          <span key={i} className="flex items-center gap-8 text-sm sm:text-base font-heading font-bold uppercase tracking-[0.25em] text-white">
            {item}
            <span className="h-1.5 w-1.5 rounded-full bg-white/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
